export default "/profile/images/instruction-1-ru.webp?ed312c0931f832c07322e8dd034dc486";